// extracted by mini-css-extract-plugin
export var dropdownIcon = "_kk-6";
export var imgContainer = "_kk-3";
export var menuIcon = "_kk-5";
export var pillWrapper = "_kk-2";
export var pillsContainer = "_kk-1";
export var subscriptionCard = "_kk-0";
export var subscriptionLogo = "_kk-4";